export default "__VITE_ASSET__D8UXwA5y__"